import React from "react";
import { SidebarProps } from "./types";

export default function Sidebar({
  items,
  logo,
  onNavigate,
  onLogoClick,
}: SidebarProps) {
  const [width, setWidth] = React.useState<number>(150);
  const storedWidth = React.useRef<number | null>(null);

  React.useEffect(() => {
    if (storedWidth.current === null) {
      const saved = localStorage.getItem("sidebar_w");
      if (saved) {
        setWidth(Number(saved));
        storedWidth.current = Number(saved);
      }
    }
  }, []);

  React.useEffect(() => {
    if (storedWidth.current !== width) {
      localStorage.setItem("sidebar_w", String(width));
      storedWidth.current = width;
    }
  }, [width]);

  return (
    <aside
      className="relative border-r border-gray-200 bg-white/90 backdrop-blur-md"
      style={{ width }}
      aria-label="Sidebar"
    >
      <div className="h-full flex flex-col py-2">
        <button
          type="button"
          onClick={onLogoClick}
          className="rounded-2xl bg-white shadow-md p-5 my-1 w-full text-left hover:opacity-90 cursor-pointer select-none focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          aria-label={logo.alt ?? "logo"}
        >
          <img
            src={logo.img}
            alt={logo.alt ?? "logo"}
            className="h-[130px] w-full object-contain pointer-events-none"
            draggable={false}
          />
        </button>

        <nav className="mt-6 space-y-4">
          {items.length > 0 &&
            items.map((item) => {
              const isActive = !!item.active;
              const btnClass = [
                "group flex flex-col items-center justify-center w-full px-3 py-4 min-h-[84px] transition-colors",
                isActive
                  ? "bg-blue-100 text-gray-900"
                  : "text-gray-900 hover:bg-blue-100",
              ].join(" ");
              return (
                <button
                  key={item.id}
                  onClick={() => onNavigate?.(item.id)}
                  className={`${btnClass} cursor-pointer`}
                  aria-current={isActive ? "page" : undefined}
                >
                  <span className="grid place-items-center h-10 w-10 mb-0 shrink-0">
                    <img
                      src={item.icon}
                      alt={`${item.label} icon`}
                      className="h-5 w-5 object-contain"
                    />
                  </span>
                  <span className="text-sm font-medium leading-tight text-center">
                    {item.label}
                  </span>
                </button>
              );
            })}
        </nav>

        <div className="flex-grow" />
      </div>
    </aside>
  );
}
